import * as React from 'react';
import { Button, Dropdown, Popup, Icon } from 'semantic-grab-ui/src';
import _ from 'lodash';
import {
  ActionWidget,
  ConditionWidget,
  DelayWidget,
} from 'components/form/trident-campaigns';
import classnames from 'classnames';
import { getNodePopupContent } from 'omega-rtc/utils/trident-node-utils';
import './FlowDesign.scss';
import { preOrderTraversalFromCurrentNodeToItsChildren, renderDropdownItem, getNodeTypeChildOptions } from './util';
import { CampaignWidgetProps } from 'types/ts/campaigns';
import { nodeTypes } from 'data/trident-types';
import './widget.scss';

export default class ExperimentTreatmentWidget extends React.Component<
  CampaignWidgetProps
> {
  render() {
    const { model, canActivate, currentNodeKey, parentKeyList, childIndex } = this.props;

    const noOfChildren = _.get(model.nodes[currentNodeKey], 'children', [])
      .length;
    const groupID = _.get(model.nodes[currentNodeKey], 'data.groupID', 0);
    const renderAddButton = noOfChildren < 1;
    // check whether flow is completed or not, it will help to render add button with set of options after flow completed.
    const flowCompleted = preOrderTraversalFromCurrentNodeToItsChildren(
      model,
      currentNodeKey,
      true,
    );
    const addButtonAfterFlow = noOfChildren < 1 && flowCompleted;
    // preparing ancestor list of current clicked node to send it into node preview display.
    const ancestorList = _.concat(parentKeyList, currentNodeKey);
    const parentKey = parentKeyList[parentKeyList.length - 1];
    const nodesOccMap = _.get(model, 'nodesOccMap');
    const parentHasChildren =
      _.get(this.props.model.nodes[parentKey], 'children', []).length > 1;
    const nameData = nodesOccMap.experimentTreatment.find(
      x => x.nodeID === currentNodeKey,
    );

    const treatmentPercentages = _.get(model.nodes[parentKey], 'data.groupPercentage', []);
    const controlPercentage = 100 - _.sum(treatmentPercentages);

    const defaultName =
      groupID === 0 ? `Control Group ${controlPercentage}%` : `ET${_.get(nameData, 'key')} ${treatmentPercentages[childIndex - 1]}%`;
    const rootNode = parentKeyList[0];
    const childOptions = _.get(model.nodes[rootNode], 'type') == nodeTypes.schedule ? [nodeTypes.actions] : getNodeTypeChildOptions(model.targetUserType,nodeTypes.experimentTreatment);


    return (
      <div
        className={classnames('entry', 'experimentTreatmentNode', {
          sole: !parentHasChildren,
        })}
      >
        <span className="wrapDesign">
          <Popup
            trigger={
              <Button
                className={classnames('button', {
                  buttonClicked:
                    this.props.clickedNode === this.props.currentNodeKey,
                })}
                onClick={() =>
                  this.props.handleNodePreview(ancestorList, currentNodeKey)
                }
              >
                {_.get(model.nodes[currentNodeKey], 'name') || defaultName}
              </Button>
            }
            content={getNodePopupContent(
              model,
              'name',
              currentNodeKey,
              defaultName,
            )}
          />
          {(renderAddButton || addButtonAfterFlow) && (
            <Dropdown
              icon="plus square"
              floating
              basic
              className="icon addButton"
            >
              <Dropdown.Menu>
                {childOptions.map(option =>
                  renderDropdownItem(`Add ${option}`, () => this.props.handleAddNode(option, currentNodeKey, ancestorList))
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}
        </span>
        {_.get(model.nodes[currentNodeKey], 'children', []).length > 0 && (
          <div
            className={
              renderAddButton || addButtonAfterFlow
                ? 'dropdownButton'
                : 'noDropdownButton'
            }
          >
            {_.get(model.nodes[currentNodeKey], 'children', []).map(
              (childKey, index) => {
                if (model.nodes[childKey].type === 'condition') {
                  return (
                    <ConditionWidget
                      key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                      onModelChange={this.props.onModelChange}
                      model={model}
                      currentNodeKey={childKey}
                      canActivate={canActivate}
                      parentKeyList={ancestorList}
                      handleAddNode={this.props.handleAddNode}
                      handleNodePreview={this.props.handleNodePreview}
                      clickedNode={this.props.clickedNode}
                    />
                  );
                }
                if (model.nodes[childKey].type === 'delay') {
                  return (
                    <DelayWidget
                      key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                      onModelChange={this.props.onModelChange}
                      model={model}
                      currentNodeKey={childKey}
                      canActivate={canActivate}
                      parentKeyList={ancestorList}
                      handleAddNode={this.props.handleAddNode}
                      handleNodePreview={this.props.handleNodePreview}
                      clickedNode={this.props.clickedNode}
                    />
                  );
                }
                return (
                  <ActionWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    onModelChange={this.props.onModelChange}
                    model={model}
                    currentNodeKey={childKey}
                    canActivate={canActivate}
                    parentKeyList={ancestorList}
                    handleNodePreview={this.props.handleNodePreview}
                    clickedNode={this.props.clickedNode}
                  />
                );
              },
            )}
          </div>
        )}
      </div>
    );
  }
}
